import { Modal, Table } from "../../../../components";
import { useAdminStore } from "../../../../store/adminStore";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import ViewMap from "../../../../components/ViewMap";
import { useEffect, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import {
  handlerCambiarEstado,
  handlerCancelar,
  handlerFinalizarActa,
} from "../../../../handlers/actas.handler";
import { usePodadoresStore } from "../../../../store/podadoresStore";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useFormActaStore } from "../../../../store/formActaStore";
import StarRating from "../../../../components/StarRating";
import Loading from "../../../../components/Loading";
import { useForm } from "react-hook-form";
import SubirFotosCustom from "../../../../components/SubirFotosCustom/SubirFotosCustom";
import { useInspectorStore } from "../../../../store/inspectorStore";
import { yupResolver } from "@hookform/resolvers/yup";
import { schemaActaPaso3 } from "../../../../schemas/validacionesActa";
import { handlerSubirConstatacion } from "../../../../handlers/admin.handler";

const ModalConstatacionAdmin = ({ actaId }) => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const { podadores, podadoresSelect, setPodadoresSelect } = usePodadoresStore();
  const { width } = useWindowSize();
  // const { acta } = useInspectorStore();
  const { acta } = useAdminStore();

  const [ratings, setRatings] = useState({});
  /* const [podadoresSelect, setPodadoresSelect] = useState([]) */

  const handleRating = (podadorId, value) => {
    setRatings((prev) => ({ ...prev, [podadorId]: value }));
  };

  const {
    resetField,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    // defaultValues: defaultValues,
    resolver: yupResolver(schemaActaPaso3),
  });

  const onSubmit = (data) => {
    handlerSubirConstatacion({ ...data, acta_id: acta.id });
  };

  useEffect(() => {
    return () => {
      handlerModal({ modal: false, modalName: "modal_constatacion" });
    };
  }, []);

  return (
    <>
      <Modal
        size="xl"
        show={modals.includes("modal_constatacion")}
        onHide={() => handlerModal({ modal: false, modalName: "modal_constatacion" })}
        title={() => "Subir constatación"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100 position-relative"
        >
          {loads.includes("enviar_constatacion") && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ zIndex: "9", backgroundColor: "rgba(255,255,255,0.8)" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="14px" />
            </div>
          )}
          <Alert variant="primary">
            Una vez subida la constatación, la solicitud quedara en estada de{" "}
            <b>pendiente aceptada</b>.
          </Alert>
          <Form noValidate onSubmit={handleSubmit(onSubmit)} className="col-12 mx-auto">
            <div /* className='row' */ className={`d-flex  ${width >= 992 ? "" : "flex-column"}`}>
              <section className={`${width >= 992 ? "col-5" : "col-12"}`}>
                <Form.Group className={`${width >= 992 ? "col-12" : "col-12"}`}>
                  <Form.Label>Número de acta</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("numero_acta")}
                    isInvalid={!!errors.numero_acta}
                  />
                  <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                    {errors.numero_acta?.message}
                  </Form.Control.Feedback>
                  {!errors.numero_acta?.message && <div style={{ height: "25px" }}></div>}
                </Form.Group>

                <Form.Group className={`${width >= 992 ? "col-12" : "col-12"}`}>
                  <Form.Label>Observacion de la inpección</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    style={{ resize: "none" }}
                    rows={3}
                    // type="text"
                    {...register("observacion")}
                    isInvalid={!!errors.observacion}
                  />
                  <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                    {errors.observacion?.message}
                  </Form.Control.Feedback>
                  {!errors.observacion?.message && <div style={{ height: "25px" }}></div>}
                </Form.Group>

                <Form.Group className={`${width >= 992 ? "col-12" : "col-12"}`}>
                  <Form.Label>Constatación del daño</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    style={{ resize: "none" }}
                    rows={3}
                    // type="text"
                    {...register("constatacion_dano")}
                    isInvalid={!!errors.constatacion_dano}
                  />
                  <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                    {errors.constatacion_dano?.message}
                  </Form.Control.Feedback>
                  {!errors.constatacion_dano?.message && <div style={{ height: "25px" }}></div>}
                </Form.Group>

                <Form.Group className={`${width >= 992 ? "col-12" : "col-12"}`}>
                  <Form.Label>Descripción de tarea</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    style={{ resize: "none" }}
                    rows={3}
                    // type="text"
                    {...register("descripcion_tarea")}
                    isInvalid={!!errors.descripcion_tarea}
                  />
                  <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                    {errors.descripcion_tarea?.message}
                  </Form.Control.Feedback>
                  {!errors.descripcion_tarea?.message && <div style={{ height: "25px" }}></div>}
                </Form.Group>
              </section>
              <section className={`${width >= 992 ? "col-7" : "col-12"}`}>
                <label className="mx-auto  w-100 text-center mb-1">Adjuntar archivos de acta</label>
                <SubirFotosCustom
                  watch={watch}
                  errors={errors}
                  setValue={setValue}
                  campo={"constatacion_file"}
                  multiple={false}
                />
              </section>
            </div>
            <div>
              <hr />
              <div
                className={` d-flex  ${
                  width >= 640 ? "justify-content-end" : "justify-content-center py-4"
                }  gap-2`}
              >
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    handlerModal({ modal: false, modalName: "modal_constatacion" });
                  }}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  type="submit"
                  // onClick={() => handlerCancelar(actaId)}KU
                >
                  Confirmar
                </button>
              </div>
            </div>
          </Form>
        </motion.div>
        {/* {modals.includes("asignar_podadores") && <ModalAsignarPodadores />} */}
      </Modal>
    </>
  );
};
export default ModalConstatacionAdmin;
